import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ellipsesMultipleLines, Link } from '@codex/basics';
import { formatPrice } from '@codex/helpers';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding-left: 40px;
  box-sizing: border-box;
`;

const Image = styled.img`
  width: 33px;
  height: 34px;
  margin-right: 13px;
`;

const Content = styled.div`
  line-height: 1.4;
`;

const Title = styled.div`
  ${ellipsesMultipleLines(1)};
`;

const Price = styled.div`
  font-weight: bold;
`;

const CurrentPrice = styled.span`
  padding-right: 5px;
  color: ${props => props.theme.colors.price.default};
`;

const SavePrice = styled.span`

`;

const NotificationLink = styled(Link)`
  margin: 15px 0;
  display: block;
  &:first-child {
    margin-top: 4px;
  }
  &:last-child {
    margin-bottom: 11px;
  }
`;

const PriceDropNotification = (props) => {
  const productIdParam = `?lastProductId=${props.wishlistId}--${props.productId}#`;
  const url = props.savedForLaterLink.replace('#', productIdParam);

  return (
    <NotificationLink
      href={url}
      data-track="price drop:delete"
    >
      <Wrapper>
        <Image
          src={props.productImage}
          alt={props.productTitle}
        />
        <Content>
          <Title>{props.productTitle}</Title>
          <Price>
            <CurrentPrice>{formatPrice(props.currentPrice)}</CurrentPrice>
            <SavePrice>Save {formatPrice(props.savePrice)}</SavePrice>
          </Price>
        </Content>
      </Wrapper>
    </NotificationLink>
  );
};

PriceDropNotification.propTypes = {
  currentPrice: PropTypes.string,
  savePrice: PropTypes.string,
  productImage: PropTypes.string,
  productTitle: PropTypes.string,
  wishlistId: PropTypes.number,
  productId: PropTypes.number,
  savedForLaterLink: PropTypes.string.isRequired
};

PriceDropNotification.defaultProps = {
  currentPrice: undefined,
  savePrice: undefined,
  productImage: undefined,
  productTitle: undefined,
  wishlistId: undefined,
  productId: undefined
};

export default PriceDropNotification;
